import React from 'react';
export default function WizardStepNode({children}:any){
 return <>{children}</>
}
